import React, { createContext, useContext, useState, useEffect } from 'react';
import { applicationApi, questionnaireApi } from '../services/api';
import { useAuth } from './AuthContext';

const FeedbackContext = createContext();

export const useFeedback = () => {
  const context = useContext(FeedbackContext);
  if (!context) {
    throw new Error('useFeedback must be used within a FeedbackProvider');
  }
  return context;
};

export const FeedbackProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [shouldShowFeedback, setShouldShowFeedback] = useState(false);
  const [hasFirstApplication, setHasFirstApplication] = useState(false);
  const [hasFeedback, setHasFeedback] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      checkFeedbackStatus();
    }
  }, [isAuthenticated]);

  const checkFeedbackStatus = async () => {
    if (!isAuthenticated) {
      return;
    }
    
    try {
      // Check if user has applications
      const appResponse = await applicationApi.getAllApplications();
      const hasApplications = appResponse.data && appResponse.data.length > 0;
      setHasFirstApplication(hasApplications);
      
      // Check if user has filled any questionnaire
      const questionnaireResponse = await questionnaireApi.getUserQuestionnaires();
      const hasQuestionnaire = questionnaireResponse.data && questionnaireResponse.data.length > 0;
      setHasFeedback(hasQuestionnaire);
      
      // Show banner if has applications but no questionnaire records
      setShouldShowFeedback(hasApplications && !hasQuestionnaire);
    } catch (error) {
      console.error('Error checking feedback status:', error);
    }
  };

  const triggerFeedbackNotification = () => {
    // Always check current status when triggered
    checkFeedbackStatus();
  };

  const hideFeedbackNotification = () => {
    setShouldShowFeedback(false);
    setHasFeedback(true);
  };

  return (
    <FeedbackContext.Provider value={{
      shouldShowFeedback,
      triggerFeedbackNotification,
      hideFeedbackNotification,
      checkFeedbackStatus
    }}>
      {children}
    </FeedbackContext.Provider>
  );
};